<template>
<div>
  <my-header></my-header>

  <div class="content-container-level-1">
    <h2>New derby template</h2>

    <b-form @submit="onSubmit">
      <div class="form-group">
        <label for="template-name">Template name:</label>
        <b-form-input id="template-name" v-model="form.name" type="text" required></b-form-input>
      </div>

      <div class="form-row">
        <div class="form-group col">
          <label for="min-player-level">Min player level:</label>
          <b-form-input id="min-player-level" v-model="form.minPlayerLevel" type="number" number required></b-form-input>
        </div>
        <div class="form-group col">
          <label for="max-player-level">Max player level:</label>
          <b-form-input id="max-player-level" v-model="form.maxPlayerLevel" type="number" number required></b-form-input>
        </div>
      </div>

      <div class="form-group">
        <label for="max-participants">Max participants:</label>
        <b-form-input id="max-participants" v-model="form.maxParticipants" type="number" number required></b-form-input>
      </div>

      <div class="form-group">
        <label for="target-score">Target score:</label>
        <b-form-input id="target-score" v-model="form.targetScore" type="number" number required></b-form-input>
      </div>

      <div class="form-group">
        <label for="score-threshold">Score threshold:</label>
        <b-form-input id="score-threshold" v-model="form.scoreThreshold" type="number" number required></b-form-input>
      </div>

      <fieldset class="form-group">
        <legend>Score emul time step</legend>
        <duration-input v-model="form.scoreEmulTimeStep"></duration-input>
      </fieldset>

      <fieldset class="form-group">
        <legend>Score emul total time</legend>
        <duration-input v-model="form.scoreEmulTimeTotal"></duration-input>
      </fieldset>

      <fieldset class="form-group">
        <legend>Rewards</legend>
        <rewards-input v-model="form.rewards"></rewards-input>
      </fieldset>

      <b-button :to="{name: 'derby_template_list'}">Cancel</b-button>
      <b-button type="submit" variant="primary">Create</b-button>
    </b-form>
  </div>
</div>
</template>

<script>
import MyHeader from '../Header.vue';
import DurationInput from '../DurationInput.vue';
import RewardsInput from '../RewardsInput.vue';

import { HTTP } from '../../http-common';
import notifier from '../../notifier';

export default {
  name: 'DerbyTemplateAdd',
  components: {
    MyHeader,
    DurationInput,
    RewardsInput,
  },

  data() {
    return {
      form: {
        name: '',
        minPlayerLevel: 0,
        maxPlayerLevel: 0,
        maxParticipants: 0,
        targetScore: 0,
        scoreThreshold: 0,
        scoreEmulTimeStep: 0,
        scoreEmulTimeTotal: 0,
        rewards: [],
      },
    };
  },
  
  methods: {
    onSubmit(evt) {
      evt.preventDefault();

      const data = JSON.stringify(this.form);

      HTTP.post('/derbies/templates/add', data, {headers: {'Content-Type': 'application/json'}})
      .then(response => {
        const result = response.data.result;

        if (result.code) {
          notifier.showError(result.message, {sender: this});
          return;
        }

        notifier.showSuccessAfterTransition('Derby template added.');
        this.$router.push({name: 'derby_template_list'});
      })
      .catch(e => {
        notifier.showError(e, {sender: this});
      });
    },
  },
}
</script>

<style scoped>
fieldset.form-group {
  border: 1px solid #ced4da;
  border-radius: 0.25em;
  margin-left: 0;
  margin-right: 0;
}
fieldset > legend {
  font-size: 1.25em;
}
</style>